import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr';

class GCNotifications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sortBy: 'name',
            sortOrder: 1,
            editOpen: false,
            selectedId: null,
            scheduleAt: null,
            scheduleSubmitting: false,
            sendSubmitting: false,
            error: ''
        };
    }

    // --- Helpers --------------------------------------------------------------

    getList() {
	console.log("this.props.data")
	console.log(this.props.data)
        const list = this.props.data.GCNotifications.data || [];
        const { sortBy, sortOrder } = this.state;

        const sorted = [...list].sort((a, b) => {
            const A = (a?.[sortBy] ?? '').toString().toLowerCase();
            const B = (b?.[sortBy] ?? '').toString().toLowerCase();
            if (A === B) {
                const aName = (a?.name ?? '').toLowerCase();
                const bName = (b?.name ?? '').toLowerCase();
                if (aName === bName) return 0;
                return aName > bName ? sortOrder : -sortOrder;
            }
            return A > B ? sortOrder : -sortOrder;
        });

        return sorted;
    }

    getSelected() {
        const list = this.props.data.GCNotifications.data || [];
        return list.find((n) => n.id === this.state.selectedId) || null;
    }

    // --- UI state -------------------------------------------------------------

    openEditor = (id) => () => {
        this.setState({ editOpen: true, selectedId: id, error: '' });
    };

    cancel = () => {
        this.setState({
            editOpen: false,
            selectedId: null,
            scheduleAt: null,
            scheduleSubmitting: false,
            sendSubmitting: false,
            error: ''
        });
    };

    sort = (field) => () => {
        const sortOrder = this.state.sortBy === field ? this.state.sortOrder * -1 : 1;
        this.setState({ sortBy: field, sortOrder });
    };

    sortIcon(field) {
        if (this.state.sortBy !== field) return '';
        return this.state.sortOrder === 1 ? ' \u25B2' : ' \u25BC';
    }

    // --- Actions --------------------------------------------------------------

    sendNow = async () => {
        const notif = this.getSelected();
        if (!notif) return;

        this.setState({ sendSubmitting: true, error: '' });
        try {
            const payload = { route: 'notificationsSendNow', id: notif.id };
            this.props.ws?.send?.(JSON.stringify(payload));
            this.setState({ sendSubmitting: false });
            this.cancel();
        } catch (e) {
            this.setState({ error: 'Failed to send. Check connection.', sendSubmitting: false });
        }
    };

    schedule = async () => {
        const notif = this.getSelected();
        if (!notif) return;

        if (!this.state.scheduleAt) {
            this.setState({ error: 'Pick a date/time to schedule.' });
            return;
        }

        this.setState({ scheduleSubmitting: true, error: '' });
        try {
            const iso = new Date(this.state.scheduleAt).toISOString();
            const payload = { route: 'notificationsSchedule', id: notif.id, scheduleAt: iso };
            this.props.ws?.send?.(JSON.stringify(payload));
            this.setState({ scheduleSubmitting: false });
            this.cancel();
        } catch (e) {
            this.setState({ error: 'Failed to schedule. Check connection.', scheduleSubmitting: false });
        }
    };

    // --- Render ---------------------------------------------------------------

    renderEditor() {
        if (!this.state.editOpen) return null;
        const notif = this.getSelected();
        if (!notif) return null;

        return (
            <div className="blackout" onClick={(e) => e.target.className === 'blackout' && this.cancel()}>
                <div className="pop">
                    <div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel} />
                    <div className="loginLabel">Notification</div>
                    {this.state.error && <div className="error">{this.state.error}</div>}

                    <div style={{ marginBottom: 12 }}>
                        <div style={{ fontWeight: 'bold', fontSize: 22 }}>
                            {notif.name || notif.title || 'Untitled'}
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 8 }}>
                        <div
                            className="button confirm"
                            onClick={!this.state.sendSubmitting ? this.sendNow : undefined}
                            title="Send immediately"
                            style={this.state.sendSubmitting ? { opacity: 0.6, pointerEvents: 'none' } : undefined}
                        >
                            {this.state.sendSubmitting ? 'Sending…' : 'Send Now'}
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '8px 0' }}>
                            <div style={{ flex: 1, height: 1, background: '#ddd' }} />
                            <div style={{ fontSize: 14, color: '#666' }}>OR</div>
                            <div style={{ flex: 1, height: 1, background: '#ddd' }} />
                        </div>

                        <div
                            style={{
                                border: '1px solid #ddd',
                                borderRadius: 6,
                                padding: 12,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                                background: '#f9f9f9'
                            }}
                        >
                            <Flatpickr
                                options={{ enableTime: true, time_24hr: false, minuteIncrement: 1 }}
                                value={this.state.scheduleAt}
                                onChange={(dates) => this.setState({ scheduleAt: dates?.[0] || null })}
                                placeholder="Pick date & time"
                                style={{
                                    height: 40,
                                    padding: '0 10px',
                                    border: '1px solid #ddd',
                                    borderRadius: 4,
                                    width: 220
                                }}
                            />
                            <div
                                className="button confirm"
                                onClick={!this.state.scheduleSubmitting ? this.schedule : undefined}
                                title="Schedule for later"
                                style={this.state.scheduleSubmitting ? { opacity: 0.6, pointerEvents: 'none' } : undefined}
                            >
                                {this.state.scheduleSubmitting ? 'Scheduling…' : 'Schedule'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderRow = (n) => {
        const name = n.name || n.title || 'Untitled';
        const when = n.lastSendTime || '';
        const by = n.lastUpdatedUser || n.updatedBy || n.owner || '';
        const status = n.status || '';
        const lastUpdated = n.lastUpdatedDate || '';
        //Make the date look better
        const formatDate = (dateString) => {
            if (!dateString) return '';
            const ms = Date.parse(dateString);
            if (isNaN(ms)) return '';
            const options = {
                year: 'numeric', month: 'short', day: '2-digit',
                hour: '2-digit', minute: '2-digit', hour12: true
            };
            return new Date(ms).toLocaleString(undefined, options);
        };

        const whenFormatted = formatDate(when);
        const lastUpdatedFormatted = formatDate(lastUpdated);

        return (
            <tr className="dataRow" key={n.id} onClick={this.openEditor(n.id)}>
                <td style={{ flex: '1 0 200px', textAlign: 'left' }}>{name}</td>
                <td style={{ flex: '0 0 310px', textAlign: 'left' }}>{status}</td>
                <td style={{ flex: '0 0 220px', textAlign: 'left' }}>{whenFormatted}</td>
                <td style={{ flex: '0 0 220px', textAlign: 'left' }}>{by}</td>
                <td style={{ flex: '0 0 220px', textAlign: 'right' }}>{lastUpdatedFormatted}</td>
            </tr>
        );
    };

    render() {
        if (!this.props.active) {
            return <div width="100%"></div>;
        }

        const list = this.getList();

        return (
            <div width="100%">
                <div style={{ flex: 1 }}>
                    <table>
                        <thead>
                            <tr className="dataRow">
                                <th style={{ minWidth: '200px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort('name')}>
                                    Name {this.sortIcon('name')}
                                </th>
                                <th style={{ minWidth: '310px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort('status')}>
                                    Status {this.sortIcon('status')}
                                </th>
                                <th
                                    style={{ minWidth: '220px', cursor: 'pointer', textAlign: 'left' }}
                                    onClick={this.sort('lastSendTime')}
                                >
                                    Last Send Date/Time {this.sortIcon('lastSendTime')}
                                </th>
                                <th
                                    style={{ minWidth: '220px', cursor: 'pointer', textAlign: 'left' }}
                                    onClick={this.sort('lastUpdatedUser')}
                                >
                                    Last Updated User {this.sortIcon('lastUpdatedUser')}
                                </th>
                                <th
                                    style={{ minWidth: '220px', cursor: 'pointer', textAlign: 'right' }}
                                    onClick={this.sort('lastUpdatedDate')}
                                >
                                    Last Updated Date/Time {this.sortIcon('lastUpdatedDate')}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {list.map(this.renderRow)}
                            {list.length === 0 && (
                                <tr className="dataRow">
                                    <td colSpan={5} style={{ padding: 16, opacity: 0.7 }}>
                                        No notifications found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {this.renderEditor()}
            </div>
        );
    }
}

const icon = 'menuBell';
const roles = ['View'];

export { GCNotifications, icon, roles };
